'use client';

import { c as _c } from "react/compiler-runtime";
import { Spinner } from '@common/components';
import { useToast } from '@common/hooks';
import { useInfiniteQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useInView } from 'react-intersection-observer';
import { AuthInfiniteQueryOptions, AuthMutation, UnauthInfiniteQueryOptions } from '@/api';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useAuthStore } from '@/stores/AuthStore';
import { filledInfiniteQueryOptions } from '@/utils/filledInfiniteQueryOptions';
import { Comment } from './_components/Comment';
import { CommentForm } from './_components/CommentForm';
const INITIAL_PAGE = 1;
const INITIAL_SIZE = 20;
interface TabContentCommentsProps {
  donationBusinessId: number;
}

/**
 * * 지정기부사업상세 - 응원하기 탭
 */
export const TabContentComments = t0 => {
  const $ = _c(64);
  const {
    donationBusinessId
  } = t0;
  const {
    toast,
    toastError
  } = useToast();
  const queryClient = useQueryClient();
  const isLogin = useAuthStore(_temp);
  const router = useCustomRouter();
  let t1;
  if ($[0] !== donationBusinessId || $[1] !== isLogin) {
    t1 = filledInfiniteQueryOptions(isLogin ? AuthInfiniteQueryOptions["get:/wello/v2/auth/home/donation-business-comment"]({
      query: {
        donationBusinessId,
        page: INITIAL_PAGE,
        size: INITIAL_SIZE
      }
    }) : UnauthInfiniteQueryOptions["get:/wello/v2/allows/home/donation-business-comment"]({
      query: {
        page: INITIAL_PAGE,
        size: INITIAL_SIZE,
        donationBusinessId
      }
    }));
    $[0] = donationBusinessId;
    $[1] = isLogin;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = {
      ...t1
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching
  } = useInfiniteQuery(t2);
  let t3;
  if ($[5] !== fetchNextPage || $[6] !== isFetching) {
    t3 = {
      onChange: inView => {
        if (!isFetching && inView) {
          fetchNextPage();
        }
      }
    };
    $[5] = fetchNextPage;
    $[6] = isFetching;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    ref
  } = useInView(t3);
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = AuthMutation["post:/wello/v2/auth/home/donation-business-comment"]();
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== queryClient || $[10] !== toast) {
    t5 = () => {
      toast({
        message: "\uC751\uC6D0\uC774 \uB4F1\uB85D\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
      });
      queryClient.invalidateQueries();
    };
    $[9] = queryClient;
    $[10] = toast;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== toastError) {
    t6 = error => {
      toastError({
        error
      });
    };
    $[12] = toastError;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = {
      ...t4,
      onSuccess: t5,
      onError: t6
    };
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const {
    mutate: createComment,
    isPending: createPending
  } = useMutation(t7);
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = AuthMutation["put:/wello/v2/auth/home/donation-business-comment"]();
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== queryClient || $[19] !== toast) {
    t9 = () => {
      toast({
        message: "\uC751\uC6D0\uC774 \uC218\uC815\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
      });
      queryClient.invalidateQueries();
    };
    $[18] = queryClient;
    $[19] = toast;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== toastError) {
    t10 = error_0 => {
      toastError({
        error: error_0
      });
    };
    $[21] = toastError;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t9) {
    t11 = {
      ...t8,
      onSuccess: t9,
      onError: t10
    };
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const {
    mutate: updateComment,
    isPending: updatePending
  } = useMutation(t11);
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = AuthMutation["delete:/wello/v2/auth/home/donation-business-comment"]();
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== queryClient || $[28] !== toast) {
    t13 = () => {
      toast({
        message: "\uC751\uC6D0\uC774 \uC0AD\uC81C\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
      });
      queryClient.invalidateQueries();
    };
    $[27] = queryClient;
    $[28] = toast;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== toastError) {
    t14 = error_1 => {
      toastError({
        error: error_1
      });
    };
    $[30] = toastError;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t13 || $[33] !== t14) {
    t15 = {
      ...t12,
      onSuccess: t13,
      onError: t14
    };
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  const {
    mutate: deleteComment,
    isPending: deletePending
  } = useMutation(t15);
  let t16;
  if ($[35] !== createComment || $[36] !== donationBusinessId || $[37] !== isLogin) {
    t16 = comment => {
      if (!isLogin) {
        return;
      }
      createComment({
        body: {
          comment,
          donationBusinessId
        }
      });
    };
    $[35] = createComment;
    $[36] = donationBusinessId;
    $[37] = isLogin;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  const handleCreate = t16;
  let t17;
  if ($[39] !== isLogin || $[40] !== updateComment) {
    t17 = (comment_0, commentId) => {
      if (!isLogin) {
        return;
      }
      updateComment({
        body: {
          comment: comment_0,
          donationBusinessCommentId: commentId
        }
      });
    };
    $[39] = isLogin;
    $[40] = updateComment;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  const handleUpdate = t17;
  let t18;
  if ($[42] !== deleteComment || $[43] !== isLogin) {
    t18 = commentId_0 => {
      if (!isLogin) {
        return;
      }
      deleteComment({
        body: {
          donationBusinessCommentId: commentId_0
        }
      });
    };
    $[42] = deleteComment;
    $[43] = isLogin;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  const handleDelete = t18;
  let t19;
  if ($[45] !== createPending || $[46] !== data?.pages || $[47] !== deletePending || $[48] !== handleCreate || $[49] !== handleDelete || $[50] !== handleUpdate || $[51] !== hasNextPage || $[52] !== isLogin || $[53] !== ref || $[54] !== router || $[55] !== updatePending) {
    const list = data?.pages.flatMap(_temp2) ?? [];
    const totalCount = data?.pages[0]?.context?.totalCount ?? 0;
    const isEmpty = totalCount < 1;
    let t20;
    if ($[57] !== isLogin || $[58] !== router) {
      t20 = () => {
        if (!isLogin) {
          router.replace(ROUTES.LOGIN.withSearchParams({
            searchParams: {
              redirect: location.pathname + location.search
            }
          }));
          return;
        }
      };
      $[57] = isLogin;
      $[58] = router;
      $[59] = t20;
    } else {
      t20 = $[59];
    }
    let t21;
    if ($[60] !== createPending || $[61] !== handleCreate || $[62] !== t20) {
      t21 = <CommentForm onSubmit={handleCreate} loading={createPending} onChange={t20} />;
      $[60] = createPending;
      $[61] = handleCreate;
      $[62] = t20;
      $[63] = t21;
    } else {
      t21 = $[63];
    }
    t19 = <section className="flex flex-col px-16 pt-16">{t21}{isEmpty ? <div className="h-[53.125rem] text-center font-400 text-Gray-550 flex-center typo-body3">아직 등록된 응원이 없어요.<br />첫 번째 응원자가 되어보세요.</div> : <><p className="w-full pb-16 pt-24 font-600 text-Gray-900 typo-body3">총{" "}<span className="text-B-500">{totalCount?.toLocaleString()}</span>개의 응원하기</p><ul className="flex flex-col">{list.map(t22 => {
            const {
              donationBusinessCommentId: donation_business_comment_id,
              profileUrl: profile_url,
              daysAgo: days_ago,
              comment: comment_1,
              mineYN: mine_yn,
              nickname,
              donationAmount: donation_amount
            } = t22;
            return <li key={donation_business_comment_id}><Comment profileUrl={profile_url} nickname={nickname} daysAgo={days_ago} mineYN={mine_yn} donationAmount={donation_amount} comment={comment_1} commentId={donation_business_comment_id} onUpdate={handleUpdate} onDelete={handleDelete} loading={updatePending || deletePending} /></li>;
          })}</ul>{hasNextPage ? <div className="my-30 w-full flex-center" ref={ref}><Spinner /></div> : null}</>}</section>;
    $[45] = createPending;
    $[46] = data?.pages;
    $[47] = deletePending;
    $[48] = handleCreate;
    $[49] = handleDelete;
    $[50] = handleUpdate;
    $[51] = hasNextPage;
    $[52] = isLogin;
    $[53] = ref;
    $[54] = router;
    $[55] = updatePending;
    $[56] = t19;
  } else {
    t19 = $[56];
  }
  return t19;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(page) {
  return page?.context?.contents ?? [];
}